import { render, staticRenderFns } from "./customizeColumns.vue?vue&type=template&id=3190c804&scoped=true"
import script from "./customizeColumns.vue?vue&type=script&lang=js"
export * from "./customizeColumns.vue?vue&type=script&lang=js"
import style0 from "./customizeColumns.vue?vue&type=style&index=0&id=3190c804&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190c804",
  null
  
)

export default component.exports